import React from "react";
export const PurpleThing8 = () => (
  <svg className="purple-thing8" version="1.2" viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg">
    <g fill="var(--contrast-lighter)" fillOpacity=".996">
      <ellipse transform="translate(1.73,1.59) rotate(28.6)" rx="1.23" ry="1.14"/>
      <ellipse transform="translate(4.63,4.89) rotate(6.8)" rx=".87" ry=".76"/>
    </g>
  </svg>
);
export default PurpleThing8;